export { default as StyledButton } from "./Button";
export { default as LineNumbers } from "./LineNumbers";
export { default as Project } from "./Project";
export { default as Skills } from "./Skills";
export { default as Social } from "./Social";


// WEBPACK FOOTER //
// ./src/components/index.js